import {
  definitions,
  paths,
} from "../../common-fetch/generated/partners-model-api";
import { fetchItJson } from "../../common-fetch/miscellaneous/fetchItJson";
import { FetchOutput } from "../../common-fetch/miscellaneous/fetchResult";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";

type Path = paths["/partners"];
export type Responses = Path["get"]["responses"];

export type FetchSettingsOutput = FetchOutput<
  Responses["200"]["schema"],
  definitions["ProblemDetails"]
>;

export async function fetchGetSettings(): Promise<FetchSettingsOutput> {
  const path: keyof paths = "/partners";

  return fetchItJson<Responses["200"]["schema"], definitions["ProblemDetails"]>(
    "authorization",
    `${getPartnerPathnameClient(true)}/Market/HostedCart/Partners/v1${path}`
  ).catch(() => {
    return { tag: "client-error", parsed: { status: 418 } };
  });
}
